import React from 'react';

function Objetivo() {
  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h2>Objetivo</h2>
      <p>Nosso objetivo é trazer conhecimento histórico de forma acessível e interativa para todos.</p>
    </div>
  );
}

export default Objetivo;
